
import Debounce from '@/decorators/debounce';
import ClientLink from '@/model/ClientLinkListElement';
import api from '@/service/api';
import Vue from 'vue'
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-module-decorators';

@Component({})
export default class LinkItem extends Vue {
    @Prop({
        type: Object,
        required: true,
    })
    link!: ClientLink;

    groupDialog = false;

    menu = false;

    registrationsLeft?: string = null as unknown as string;

    get maxRegistrationsLeft() {
        return this.link.group ? 999 - this.link.registrationsCount : 999;
    }

    @Watch('link', {
        immediate: true
    })
    linkChanged() {
        if (this.link.group) {
            this.registrationsLeft = this.link.registrationsLeft.toString();
        }
    }

    @Watch('registrationsLeft')
    @Debounce(500)
    registrationsLeftChanged() {
        if (this.registrationsLeft === undefined) {
            return;
        }

        const registrationsLeft = Number.parseInt(this.registrationsLeft);
        if (
            this.link.group &&
            registrationsLeft !== this.link.registrationsLeft
        ) {
            this.changeLinkGroupSize(registrationsLeft);
        }
    }

    copyLink() {
        this.$emit('copy', this.link);
    }

    resetLink() {
        this.$emit('reset', this.link);
    }

    generateMailto() {
        return `mailto:?subject=Link do sesji zdjęciowej&body=Adres sesji: ${this.link.url}`;
    }

    deleteLink(linkCode: string) {
        this.$emit('delete', this.link);
    }

    async changeLinkGroupSize(groupSize: number) {
        await api.changeLinkGroupSize(this.link.code, groupSize);
        (this as any).$vToastify.success({
            title: 'Zaktualizowano',
            body: 'Zmieniono rozmiar grupy',
        });
        this.$emit('update');
    }
}
